import { indexData } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            专题索引
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            按分类快速浏览全站影视内容资源
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {indexData.map((item, i) => (
            <a
              key={i}
              href={item.href}
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector(item.href);
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 font-heading font-bold text-base">
                {item.letter}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                  {item.label}
                </div>
                <div className="text-xs text-foreground-400 mt-0.5">
                  {item.count} 部作品
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}